import { formatarCnpj } from '@favo/core';

import { Valor } from '@/componentes/valor';
import type { CadastroAdmin } from '@/dados';
import { META_PADRAO } from '@/telas/empresa/formulario';

import { Capitulo, Linha } from './ficha';

/* Quem é a empresa: identificação, conta e as duas premissas que ela declarou
 * sobre si (a meta de margem e o volume mensal). */

export function Cadastro({ cadastro }: { cadastro: CadastroAdmin }) {
  return (
    <Capitulo titulo="Cadastro" descricao="O que a empresa informou na etapa Empresa.">
      <div className="grid">
        <Linha rotulo="CNPJ">{cadastro.cnpj ? formatarCnpj(cadastro.cnpj) : '—'}</Linha>
        <Linha rotulo="E-mail do cadastro">{cadastro.email}</Linha>
        <Linha rotulo="WhatsApp">{cadastro.whatsapp ?? '—'}</Linha>
        <Linha rotulo="Regime">{cadastro.regime_tributario ?? '—'}</Linha>
        <Linha rotulo="Conta">
          {cadastro.anonimo
            ? 'Sem cadastro. Quem provar este e-mail assume a conta.'
            : `${cadastro.usuario_email ?? '—'}${cadastro.papel === 'admin' ? ' · tem o painel' : ''}`}
        </Linha>
        {/* Meta em PONTOS: é o que a pessoa digitou, não o que o motor produz.
            Nunca definida vale o padrão, e dizer isso evita comparar a empresa
            com uma régua que ela não escolheu. */}
        <Linha rotulo="Margem alvo">
          <Valor
            valor={cadastro.lucro_alvo ?? META_PADRAO}
            formato="percentual-pontos"
            tamanho="apoio"
          />
          {cadastro.lucro_alvo === null ? (
            <span className="text-tinta-2 text-nota"> (padrão do sistema)</span>
          ) : null}
        </Linha>
        <Linha rotulo="Projetos por mês">
          <Valor valor={cadastro.projetos_mes} formato="numero" tamanho="apoio" />
        </Linha>
        <Linha rotulo="Criada em">
          <Valor valor={cadastro.criado_em} formato="data" tamanho="apoio" />
        </Linha>
        <Linha rotulo="Última alteração">
          <Valor valor={cadastro.atualizado_em} formato="data" tamanho="apoio" />
        </Linha>
        <Linha rotulo="Último acesso">
          <Valor valor={cadastro.ultimo_acesso} formato="data" tamanho="apoio" />
        </Linha>
        <Linha rotulo="Visitas">
          <Valor valor={cadastro.acessos} formato="inteiro" tamanho="apoio" />
        </Linha>
      </div>
    </Capitulo>
  );
}
